"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionsMenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Submenu = require("../Submenu");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledSubmenuLink = (0, _styledComponents.default)(_Submenu.SubmenuLink).withConfig({
  displayName: "StyledSubmenuLink",
  componentId: "sc-1edvksm-0"
})(["text-decoration:none;font-style:normal;font-weight:normal;font-size:0.8rem;font-family:DM Sans,sans-serif;color:", " !important;svg{color:", " !important;}&:hover,&:focus{background-color:unset !important;color:", " !important;svg{color:", " !important;}}@media ", "{&:hover,&:active{background-color:", " !important;color:", " !important;svg{color:", " !important;}}}"], (0, _helpers.color)('black100'), (0, _helpers.color)('black60'), (0, _helpers.color)('black100'), (0, _helpers.color)('black60'), (0, _helpers.breakpoint)('minTablet'), (0, _helpers.color)('primary5'), (0, _helpers.color)('primary100'), (0, _helpers.color)('primary100'));

var StyledDiv = _styledComponents.default.div.withConfig({
  displayName: "StyledDiv",
  componentId: "sc-1edvksm-1"
})(["font-style:normal;font-weight:normal;font-size:1rem;padding:0;line-height:1rem;display:flex;flex:0 1 auto;align-items:center;justify-content:center;div,svg{vertical-align:middle;align-self:center;line-height:1rem;}"]);

var LinkText = _styledComponents.default.div.withConfig({
  displayName: "LinkText",
  componentId: "sc-1edvksm-2"
})(["margin-left:0.7rem;"]);

var ActionsMenuItem = function ActionsMenuItem(_ref) {
  var to = _ref.to,
      children = _ref.children,
      Icon = _ref.icon,
      Link = _ref.link,
      rest = _objectWithoutProperties(_ref, ["to", "children", "icon", "link"]);

  return _react.default.createElement(StyledSubmenuLink, _extends({
    link: Link,
    to: to
  }, rest), _react.default.createElement(StyledDiv, null, Icon ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Icon, null), _react.default.createElement(LinkText, null, children)) : _react.default.createElement(LinkText, null, children)));
};

exports.ActionsMenuItem = ActionsMenuItem;